'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoomSearchBox = exports.mapDispatchToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.mapStateToProps = mapStateToProps;
exports.submit = submit;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _filters = require('../helpers/filters');

var _query = require('../helpers/query');

var _search = require('../modules/search');

var _rooms = require('../modules/rooms');

var _filters2 = require('../modules/filters');

var _exception = require('../modules/exception');

var _pageFocusedField = require('../modules/pageFocusedField');

var _searchBox = require('../modules/searchBox');

var _SearchBox = require('../components/SearchBox');

var _SearchBox2 = _interopRequireDefault(_SearchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mapStateToprops can be either an object or a funciton
// RoomSearchBox
function mapStateToProps(state, ownProps) {
  return {
    i18n: state.i18n,
    urls: state.urls,
    location: ownProps.location,
    search: state.search,
    filters: state.filters.filters,
    priceRange: state.filters.priceRange,
    req: state.httpRequest.req,
    searchErrors: state.search.errors,
    hotelID: ownProps.hotelID,
    focusedField: state.pageFocusedField,
    display: ownProps.display || state.searchBox.display
  };
}

// mapDispatchToprops can be either an object or a funciton


// components


// api

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';
var mapDispatchToProps = exports.mapDispatchToProps = {
  push: _reactRouterRedux.push,
  fetchRoomsBegin: _rooms.fetchBegin,
  setRooms: _rooms.set,
  setSearch: _search.set,
  setFilters: _filters2.setFilters,
  setPriceRange: _filters2.setPriceRange,
  setSearchErrors: _search.setErrors,
  clearRooms: _rooms.clear,
  throwException: _exception.throwException,
  setFocusedField: _pageFocusedField.set,
  setSearchBoxDisplay: _searchBox.set
};

function submit(values, props) {
  var location = props.location,
      search = props.search,
      push = props.push,
      fetchRoomsBegin = props.fetchRoomsBegin,
      filters = props.filters,
      priceRange = props.priceRange,
      setSearchBoxDisplay = props.setSearchBoxDisplay;


  var params = (0, _extends3.default)({}, search, (0, _filters.convertToParams)({ filters: filters, priceRange: priceRange }), (0, _query.convertFormToSearchState)(values), {
    offset: '0'
  });
  setSearchBoxDisplay(params.stay.match(/\[\d+-\d+-\d+,\d+-\d+-\d+\]/) ? 'text' : 'form');
  fetchRoomsBegin();
  push({
    pathname: location.pathname,
    query: (0, _query.convertStateToLocationQuery)({ search: params })
  });
}

var RoomSearchBox = exports.RoomSearchBox = function (_Component) {
  (0, _inherits3.default)(RoomSearchBox, _Component);

  function RoomSearchBox() {
    (0, _classCallCheck3.default)(this, RoomSearchBox);
    return (0, _possibleConstructorReturn3.default)(this, (RoomSearchBox.__proto__ || (0, _getPrototypeOf2.default)(RoomSearchBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(RoomSearchBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var shouldDisplayText = this.props.search.stay.match(/\[\d+-\d+-\d+,\d+-\d+-\d+\]/);
      this.props.setSearchBoxDisplay(shouldDisplayText ? 'text' : 'form');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          i18n = _props.i18n,
          search = _props.search,
          push = _props.push,
          req = _props.req,
          setSearch = _props.setSearch,
          fetchRoomsBegin = _props.fetchRoomsBegin,
          display = _props.display,
          filters = _props.filters,
          priceRange = _props.priceRange,
          searchErrors = _props.searchErrors,
          focusedField = _props.focusedField,
          setFocusedField = _props.setFocusedField,
          setSearchBoxDisplay = _props.setSearchBoxDisplay;


      var values = (0, _query.convertSearchStateToForm)(search);
      return _react2.default.createElement(_SearchBox2.default, {
        display: display,
        hasDestination: false,
        i18n: i18n,
        lang: i18n.lang,
        values: values,
        isMobile: req.useragent.isMobile,
        errors: searchErrors.filter(function (error) {
          return error.fields === 'destination' || error.fields === 'checkin' || error.fields === 'checkout';
        }),
        onChange: function onChange(values) {
          var params = (0, _extends3.default)({}, search, (0, _filters.convertToParams)({ filters: filters, priceRange: priceRange }), (0, _query.convertFormToSearchState)(values));
          setSearch(params);
        },
        onSubmit: function onSubmit(values) {
          submit(values, {
            location: location,
            search: search,
            push: push,
            fetchRoomsBegin: fetchRoomsBegin,
            filters: filters,
            priceRange: priceRange,
            setSearchBoxDisplay: setSearchBoxDisplay
          });
        },
        focusedField: focusedField,
        setFocusedField: setFocusedField,
        submitText: i18n.searchForm.checkAvailability,
        setSearchBoxDisplay: setSearchBoxDisplay
      });
    }
  }]);
  return RoomSearchBox;
}(_react.Component);

RoomSearchBox.propTypes = {
  location: _react.PropTypes.object.isRequired,
  i18n: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object,
  push: _react.PropTypes.func.isRequired,
  req: _react.PropTypes.object,
  setSearch: _react.PropTypes.func.isRequired,
  fetchRoomsBegin: _react.PropTypes.func.isRequired,
  filters: _react.PropTypes.array.isRequired,
  priceRange: _react.PropTypes.object.isRequired,
  display: _react.PropTypes.oneOf(['text', 'form']),
  searchErrors: _react.PropTypes.array.isRequired,
  focusedField: _react.PropTypes.object,
  setFocusedField: _react.PropTypes.func,
  setSearchBoxDisplay: _react.PropTypes.func.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RoomSearchBox);


//////////////////
// WEBPACK FOOTER
// ./src/containers/RoomSearchBox.js
// module id = 1241
// module chunks = 0